module.exports = __webpack_public_path__ + "static/browserextension-c40852fc5a593a6df96e4a5651e6816b.png";